module.exports = __webpack_public_path__ + "img/marron.cad2138d.png";